import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import type { Observable } from 'rxjs';
import type { ImportProgress } from '../../../../common/interfaces/import-progress';
import type { ContractorsImportData } from '../constants/contractors-import-schema';
import { ContractorsService } from '../services/contractors.service';

export const importContractorsResolver: ResolveFn<
  (data: ContractorsImportData[]) => Observable<ImportProgress>
> = () => {
  const contractorsService = inject(ContractorsService);
  return (data) => contractorsService.importContractors(data);
};
